import React, { Component } from "react";
import "./App.css";

import Logo from "./images/logo.png";
import Coin from "./images/dice/coin.png";
import D4 from "./images/dice/D4.png";
import D6 from "./images/dice/D6.png";
import D8 from "./images/dice/D8.png";
import D10 from "./images/dice/D10.png";
import Dper from "./images/dice/Dper.png";
import D12 from "./images/dice/D12.png";
import D20 from "./images/dice/D20.png";

import Coin_o from "./images/dice_outlines/coin_o.png";
import D4_o from "./images/dice_outlines/D4_o.png";
import D6_o from "./images/dice_outlines/D6_o.png";
import D8_o from "./images/dice_outlines/D8_o.png";
import D10_o from "./images/dice_outlines/D10_o.png";
import Dper_o from "./images/dice_outlines/Dper_o.png";
import D12_o from "./images/dice_outlines/D12_o.png";
import D20_o from "./images/dice_outlines/D20_o.png";

import Dice from "./Dice/Dice";
import Result from "./Result/Result";
import Reset from "./Reset/Reset";

class App extends Component {
  state = {
    dice: [
      {
        id: "two",
        name: "Coin",
        faces: 2,
        image: Coin,
        outline: Coin_o
      },
      { id: "four", name: "D4", faces: 4, image: D4, outline: D4_o },
      { id: "six", name: "D6", faces: 6, image: D6, outline: D6_o },
      { id: "eight", name: "D8", faces: 8, image: D8, outline: D8_o },
      { id: "ten", name: "D10", faces: 10, image: D10, outline: D10_o },
      {
        id: "percent",
        name: "Dpercentile",
        faces: 10,
        image: Dper,
        outline: Dper_o
      },

      { id: "twelve", name: "D12", faces: 12, image: D12, outline: D12_o },
      {
        id: "twenty",
        name: "D20",
        faces: 20,
        image: D20,
        outline: D20_o
      }
    ],
    results: []
  };

  rollDiceHandler = (faces, outline) => {
    let roll = Math.floor(Math.random() * faces) + 1;
    if (outline === Dper_o) {
      roll = roll * 10;
    } else if (outline === Coin_o && roll === 1) {
      roll = "heads";
    } else if (outline === Coin_o && roll === 2) {
      roll = "tails";
    } else {
      roll = roll;
    }

    const newResults = [...this.state.results];
    newResults.unshift({
      roll: roll,
      faces: faces,
      outline: outline
    });

    this.setState({ results: newResults });
  };

  resetHandler = () => {
    this.setState({ results: [] });
  };

  render() {
    const diceList = (
      <div className="dice flex">
        {this.state.dice.map(die => {
          return (
            <Dice
              name={die.name}
              key={die.id}
              image={die.image}
              click={() => this.rollDiceHandler(die.faces, die.outline)}
            />
          );
        })}
      </div>
    );

    let resultList = (
      <div className="result flex">
        {this.state.results.map((result, i) => {
          return (
            <Result
              fate={result.roll}
              faces={result.faces}
              key={i}
              outline={result.outline}
            />
          );
        })}
      </div>
    );

    return (
      <div className="App">
        <div className="sticky_footer_wrapper">
          <header>
            <img src={Logo} className="Logo" />
          </header>
          <main>
            <h1>Pick your weapon:</h1>
            {diceList}
            <h2>The gods granted you this mighty result:</h2>
            {resultList}
            <Reset click={() => this.resetHandler()} />
          </main>
        </div>
        <footer className="sticky_footer">
          Designed and Realised by <a href="norapiva.com">Nora Piva</a>
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js